module.exports = __webpack_public_path__ + "img/Trending-ResearchDAC-01.10bea9b7.svg";